<template>
  <el-dialog
    v-dialogDrag
    title="批量生成编码"
    :visible.sync="dialogVisible"
    width="45%"
    :destroy-on-close="true"
  >
    <div>
      <el-descriptions title="" :column="column">
        <el-descriptions-item label="编码代码">{{ codeData.code }}</el-descriptions-item>
        <el-descriptions-item label="编码名称">{{ codeData.name }}</el-descriptions-item>
        <el-descriptions-item
          label="生成数量"
          :label-class-name="'batch-code-number-label'"
          :content-class-name="'batch-code-number-content'"
        >
          <div class="batch-description-input">
            <el-input-number v-model="batchNumber" :max="1000" :min="1" class="batch-input-number"></el-input-number>
            <el-button type="primary" size="small" @click="generateCode">生成</el-button>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="copy-content">
        <el-input v-model="batchCodes" type="textarea" :rows="10" disabled></el-input>
        <el-button type="primary" class="copy-button" size="small" :disabled="!batchCodes" @click="handleCopy">复制</el-button>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import codeApi from "@/api/code/code";
import Clipboard from "clipboard";
export default {
  name: "BatchCodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    codeData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      column: 2,
      batchNumber: 1,
      batchCodes: ""
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  watch: {
    dialogVisible: {
      deep: true,
      immediate: true,
      handler() {
        this.batchNumber = 1;
        this.batchCodes = "";
      }
    }
  },
  methods: {
    generateCode() {
      if (!this.batchNumber || Number.isNaN(Number(this.batchNumber))) {
        this.$message.error("数量只支持有效数字，请您重新输入!");
        return;
      }
      const params = {
        autoCode: this.codeData.code,
        count: this.batchNumber
      };
      codeApi.generateCodes(params).then(res => {
        const { data } = res;
        this.batchCodes = Array.isArray(data) ? data.join(",") : "";
      });
    },
    handleCopy() {
      const clipboard = new Clipboard(".copy-button", {
        text: () => this.batchCodes
      });

      clipboard.on("success", () => {
        this.$message.success("复制成功！");
        clipboard.destroy();
      });

      clipboard.on("error", () => {
        this.$message.error("该浏览器不支持自动复制，请手动复制！");
        clipboard.destroy();
      });
    }
  }
};
</script>

<style lang="scss">

  .el-descriptions {
    .el-descriptions-row {
      .el-descriptions-item__container {
        .batch-code-number-label {
          align-items: center;
        }

        .batch-code-number-content {
          display: inline-block;
        }

        .batch-description-input {
          display: flex;

          .batch-input-number {
            flex: 1;
            margin-right: 20px;
          }
        }
      }
    }
  }

  .copy-content {
    position: relative;

    .copy-button {
      position: absolute;
      top: 0px;
      right: 0px;
    }
  }
</style>
